import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface TargetFieldCard extends AttributesMixin<typeof TargetFieldCard> { }

export enum TargetFieldType {
    Text = 1,
    DateTime = 2
}

@define
export class TargetFieldCard extends Model {
    static endpoint = restfulIO('api/v1/ingest/target-fields');

    static attributes = {
      id: String,
      name: String,
      description: String,
      assetTypeId: Number,
      targetFieldTypeId: Number,
      isRequired: Boolean,
      isActive: Boolean
    }

    getTargetFieldType(): TargetFieldType {
        return this.targetFieldTypeId as TargetFieldType;
    }
}
